import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { Routes, Route, Link } from 'react-router-dom';
import Table from './Table';
import AddData from './AddData';
import { extractRows, isDataUpdateError, isLegacyError } from './socket.guards';
import { AppointmentQueueRow, GetDataRequest, LegacyDataUpdatePayload } from './socket.types';

const App: React.FC = () => {
  const [data, setData] = useState<AppointmentQueueRow[]>([]);
  const [doctor, setDoctor] = useState('11');
  const announcementsEnabled = true;

  // Socket.IO connection - receive live updates from backend
  useEffect(() => {
    const socket = io('https://appointments-api.quantinix.com', { query: { doctor } });

    socket.on('connect', () => {
      console.log('Socket connected:', socket.id);
      // ask for initial data specifically for this doctor
      const request: GetDataRequest = { doctor };
      socket.emit('get-data', request);
    });

    socket.on('data-update', (payload: LegacyDataUpdatePayload | unknown) => {
      const rows = extractRows(payload);

      if (rows) {
        setData(rows);
      } else if (isDataUpdateError(payload) || isLegacyError(payload)) {
        console.error('Socket error payload', payload.error);
        setData([]);
      } else {
        console.warn('Unexpected socket payload for data-update', payload);
      }
    });

    socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    return () => { socket.disconnect(); };
  }, [doctor]);

  const tableData = data.map((item) => ({
    ...item,
    mobileno: item.mobileno ?? undefined,
    email: item.email ?? undefined,
    source: item.source ?? undefined,
  }));



  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', backgroundColor: '#000' }}>
      {/* <nav>
        <Link to="/">Home</Link> | <Link to="/add">Add Data</Link>
      </nav> */}
      
      <div style={{ padding: '8px 12px' }}>
        {/* <label>
          Date: 
          <input 
            type="date" 
            value={date} 
            onChange={(e) => setDate(e.target.value)}
            style={{ marginLeft: '10px', marginRight: '20px' }}
          />
        </label>
        <label>
          Doctor: 
          <input 
            type="text" 
            value={doctor} 
            onChange={(e) => setDoctor(e.target.value)}
            style={{ marginLeft: '10px' }}
          />
        </label> */}
      </div>
      <div style={{ height: 'calc(100vh - 58px)', width: '100%' }}>
        <Routes>
          <Route path="/" element={<Table data={tableData} announcementsEnabled={announcementsEnabled} />} />
          <Route path="/add" element={<AddData />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;